import { render } from "./AdminRejectReasonField.vue?vue&type=template&id=4d1dc468&scoped=true"
import script from "./AdminRejectReasonField.vue?vue&type=script&lang=js"
export * from "./AdminRejectReasonField.vue?vue&type=script&lang=js"

import "./AdminRejectReasonField.vue?vue&type=style&index=0&id=4d1dc468&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1dc468"]])

export default __exports__